import Layout from "../include/layout";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import "datatables.net-bs5";
import { Button, Form, Modal } from "react-bootstrap";
import TypesinscriptionsService from "./TypesinscriptionsService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Filarial from "../include/filarial";
import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";
import Joi from "joi-browser";

export default function TypesinscriptionsIndex() {

  const activeLink = "TYPES INSCRIPTIONS"

  const token = useSelector((state) => state.auth.token);
  const [typesinscriptions, setTypesInscriptions] = useState([]);
  const navigate = useNavigate();
  //check if user is authenticated
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);
  const [errors, setErrors] = useState({});

  const [isVisible, setIsVisible] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [addFormData, setAddFormData] = useState({
    libelleTypeInscription: '',
    descriptionTypeInscription: '',
  });

  //declaration des variables pour le form d'edition
  const [editFormData, setEditFormData] = useState({
    libelleTypeInscription: '',
    descriptionTypeInscription: '',
    id: ''
  });

  //####GESTION DES REGLES DE VALIDATIONS ###########///
  const schemaAddData = {
    libelleTypeInscription: Joi.string().min(2).max(100).required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { min: "minimum 2 caractères", max: "maximum 100" },
      },
    }).label("Libelle"),

    descriptionTypeInscription: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
      },
    }).label("Description")
  };

  //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
  const schemaEditData = {
    libelleTypeInscription: Joi.string().min(2).max(100).required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { min: "minimum 2 caractères", max: "maximum 100" },
      },
    }).label("Libelle"),

    descriptionTypeInscription: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
      },
    }).label("Description"),

    id: Joi.number().min(1).empty('').options({
      language: {
        string: { min: "minimum 1" },
      },
    }).label("Id")
  };

  //####END GESTION DES REGLES DE VALIDATIONS ###########///


  //get liste types inscriptions
  const fetchTypesinscriptions = async () => {
    await TypesinscriptionsService.index(token).then((res) => {
      //console.log(res.data.data.typesinscriptions)
      setTypesInscriptions(res.data.data.typesinscriptions);
    }).catch((error) => {
      console.log(error);
    });

    //initialize datatable
    $(document).ready(function () {
      $(".data-table").DataTable();
    });
  };


  //suppression d'un élément
  const onDelete = (param) => {
    //confirm action
    Swal.fire({
      icon: "warning",
      text: "Voulez-vous confirmer cette action ?",
      showCancelButton: true,
      cancelButtonText: "Non",
      confirmButtonText: "Oui",
      confirmButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        TypesinscriptionsService.delete(param, token)
          .then((response) => {
            //console.log(response.data)
            if (response.data.status !== 200) {
              Swal.fire({
                icon: "error",
                text: response.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                text: response.data.message,
              });
              fetchTypesinscriptions();
            }
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              text: e.message,
            });
            console.log(e);
          });
      }
    });
  };

  //Gérer les changements sur les formulaires d'ajout
  const handleChange = (event) => {
    //console.log(name)
    const { name, value } = event.target;

    setAddFormData({ ...addFormData, [name]: value });

    let errorData = { ...errors };
    const errorMessage = validateProperty(event);
    //En cas d'erreur les afficher
    if (errorMessage) {
      errorData[name] = errorMessage;
    } else {
      //Sinon supprimer l'erreur existant
      delete errorData[name];
    }

    let customerData = { ...addFormData };
    customerData[name] = event.target.value;
    setAddFormData(customerData);
    setErrors(errorData);

  }

  //Vérifie si la règle de validation est validé ou pas
  const validateProperty = (event) => {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const subSchema = { [name]: schemaAddData[name] };
    const result = Joi.validate(obj, subSchema);
    const { error } = result;
    return error ? error.details[0].message : null;
  };

  //Une fonction pour vider les champs du formulaire
  const clearForm = () => {
    setAddFormData({
      libelleTypeInscription: "",
      descriptionTypeInscription: "",
    });
  };

  //Gérer les changements sur les formulaires de modification
  const handleEditChange = (event) => {
    const { name, value } = event.target;
    setEditFormData({ ...editFormData, [name]: value });
    //console.log(editFormData)
    let errorData = { ...errors };
    const errorMessage = validateEditProperty(event);
    //En cas d'erreur les afficher
    if (errorMessage) {
      errorData[name] = errorMessage;
    } else {
      //Sinon supprimer l'erreur existant
      delete errorData[name];
    }

    let customerData = { ...editFormData };
    customerData[name] = event.target.value;
    setEditFormData(customerData);
    setErrors(errorData);

  }


  //Vérifie si la règle de validation est validé ou pas
  const validateEditProperty = (event) => {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const subSchema = { [name]: schemaEditData[name] };
    const result = Joi.validate(obj, subSchema);
    const { error } = result;
    return error ? error.details[0].message : null;
  };


  //Enregistrer un type inscription
  const handleSubmit = async (event) => {
    event.preventDefault()
    //Check si les règles de validations sont respectées avant soumission du formulaire
    const result = Joi.validate(addFormData,
      schemaAddData, { abortEarly: false });
    //console.log(result);
    const { error } = result;
    if (error) {
      const errorData = {};
      for (let item of error.details) {
        const name = item.path[0];
        const message = item.message;
        errorData[name] = message;
      }
      //console.log(errors);
      setErrors(errorData);
      return errorData;
    } else {

      //
      await TypesinscriptionsService.store(addFormData, token).then((response) => {
        //console.log(response.data.data)
        //Fermer le modal
        setIsVisible(false)
        if (response.data.status === 200) {
          //Vider les champs du formulaire
          clearForm()
          //Actualiser la liste
          fetchTypesinscriptions()
          Swal.fire({
            icon: "success",
            text: response.data.message,
            timer: 3000,
          });
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: true,
            timer: 3000,
          });
        }
      }).catch((error) => {
        setIsVisible(false)
        Swal.fire({
          icon: "error",
          text: error.message,
        });
        //affichage des erreurs sur le formulaire
        //setErrors(error.message)
      });
    }

  }

  ///Content du modal d'ajout de type d'inscription
  const addModalContent = (
    <Form className="needs-validation" noValidate onSubmit={handleSubmit}>
      <div className="col-md-12 mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-name"
        >
          Libelle <i className="text-danger">*</i>
        </Form.Label>
        <Form.Control
          className="form-control"
          id="bs-validation-libelleTypeInscription"
          type="text"
          value={addFormData.libelleTypeInscription}
          onChange={handleChange}
          placeholder="Exemple : INSCRIPTION"
          required={true}
          name="libelleTypeInscription"
          style={{ "textTransform": "uppercase" }}
        />

        {errors.libelleTypeInscription && (
          <div className="alert alert-danger">
            {errors.libelleTypeInscription}
          </div>
        )}

      </div>

      <div className="col-md-12 mb-2">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-descriptionTypeInscription" >
          Description <i className="text-danger"></i>
        </Form.Label>
        <textarea
          className="form-control"
          id="bs-validation-descriptionTypeInscription"
          onChange={handleChange}
          name="descriptionTypeInscription"
          rows="3"
          value={addFormData.descriptionTypeInscription}
        ></textarea>

        {errors.descriptionTypeInscription && (
          <div className="alert alert-danger">
            {errors.descriptionTypeInscription}
          </div>
        )}
      </div>
      <Modal.Footer className="mt-4">
        <Button variant="secondary" onClick={() => setIsVisible(false)}>
          Fermer
        </Button>
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </Modal.Footer>
    </Form>
  );

  ///Lancer le modal d'edition
  const lauchEdit = async (id) => {
    await TypesinscriptionsService.show(id, token).then((response) => {
      const data = response.data.data;
      //console.log(response.data.data)
      setEditFormData({
        libelleTypeInscription: data.libelleTypeInscription,
        descriptionTypeInscription: data.descriptionTypeInscription,
        id: data.id
      })
      setEditModal(true)
      //console.log(id)

    }).catch((error) => {
      Swal.fire({
        icon: "error",
        text: error.message,
      });
    });
  }


  //update fonction
  const handleUpdate = async (event) => {
    event.preventDefault();
    
    // Validation des données avant soumission du formulaire
    const { error } = Joi.validate(editFormData, schemaEditData, { abortEarly: false });

    if (error) {
        const errorData = {};
        for (let item of error.details) {
            const name = item.path[0];
            const message = item.message;
            errorData[name] = message;
        }
        setErrors(errorData);
        return;
    }

    try {
        const response = await TypesinscriptionsService.update(editFormData, token);
        
        setEditModal(false);
        if (response.data.status !== 200) {
            Swal.fire({
                icon: "error",
                text: response.data.message,
                showConfirmButton: false,
                timer: 3000,
            });
        } else {
            fetchTypesinscriptions(); 
            Swal.fire({
                icon: "success",
                text: response.data.message,
                showConfirmButton: false,
                timer: 3000,
            });
        }
    } catch (error) {
        setEditModal(false);
        
        Swal.fire({
            icon: "error",
            text: error.response ? error.response.data.message : error.message,
        });
    }
};



  ///Content du modal d'edition de type inscription
  const editModalContent = (
    <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
      <div className="row">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="edit-libelleTypeInscription"
        >
          Libelle <i className="text-danger">*</i>
        </Form.Label>
        <Form.Control
          className="form-control"
          id="edit-libelleTypeInscription"
          type="text"
          value={editFormData.libelleTypeInscription}
          onChange={handleEditChange}
          required={true}
          style={{ "textTransform": "uppercase" }}
          name="libelleTypeInscription"
        />

        {errors.libelleTypeInscription && (
          <div className="alert alert-danger">
            {errors.libelleTypeInscription}
          </div>
        )}

      </div>

      <div className="row mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="edit-descriptionTypeInscription" >
          Description <i className="text-danger"></i>
        </Form.Label>
        <textarea
          className="form-control"
          id="edit-descriptionTypeInscription"
          onChange={handleEditChange}
          name="descriptionTypeInscription"
          rows="3"
          value={editFormData.descriptionTypeInscription}
        ></textarea>

        {errors.descriptionTypeInscription && (
          <div className="alert alert-danger">
            {errors.descriptionTypeInscription}
          </div>
        )}

      </div>
      <Modal.Footer className="mt-4">
        <Button variant="secondary" onClick={() => setEditModal(false)}>
          Fermer
        </Button>
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </Modal.Footer>
    </Form>
  );


  useEffect(() => {
    fetchTypesinscriptions();
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }

  }, [dispatch]);

  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />

        {/* Responsive Datatable */}
        <div className="card mb-3 mt-3">
          <h5 className="card-header">
            Liste des types inscriptions &nbsp; &nbsp; &nbsp;  <Button variant="primary" onClick={() => setIsVisible(true)}>
              <FontAwesomeIcon icon="fa-solid fa-circle-plus" /> Ajouter un type inscription
            </Button>
          </h5>

          <div className="card-datatable table-responsive px-4 pb-3">
            <table className="dt-responsive table border-top data-table table-hover ">
              <thead className="bg-primary">
                <tr style={{ color: "white" }}>
                  <th className="cell text-white">#</th>
                  <th className="cell text-white">Libelle</th>
                  <th className="cell text-white">Description</th>
                  <th className="cell text-white">Statuts</th>
                  <th className="cell text-white">Date modifcation</th>
                  <th className="cell text-white">Action</th>
                </tr>
              </thead>
              <tbody>
                {typesinscriptions.length > 0 &&
                  typesinscriptions.map((item, index) => (
                    <tr key={index}>
                      <td className="cell">{index + 1}</td>
                      <td className="cell">{item.libelleTypeInscription}</td>
                      <td className="cell">
                        <span className="truncate">{item.descriptionTypeInscription}</span>
                      </td>
                      <td className="cell">
                        <span class={item.statuts?.libelleStatut === "ACTIF" ? 'badge rounded-pill bg-success' : 'badge rounded-pill bg-warning'}>{item.statuts?.libelleStatut}</span>
                      </td>
                      <td className="cell">
                        <span>
                          {dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}
                        </span>
                      </td>
                      <td className="cell">
                        <Button onClick={() => lauchEdit(item.id)}
                          className="btn btn-sm" severity="warning" style={{ color: "white" }}
                          title="Modifier"
                        >
                          <i className="fas fa-edit"></i>
                        </Button> &nbsp; &nbsp;
                        <Button
                          className="btn btn-sm" style={{ backgroundColor: "red", color: "white", border: "1px solid red" }}
                          onClick={() => onDelete(item.id)}
                          title="Supprimer"
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {/*/ Responsive Datatable */}

        {/* Modal Ajout des type inscription*/}
        <CustomAddModal
          modalTitle="Enregistrement type inscription"
          modalContent={addModalContent}
          visible={isVisible}
          close={() => setIsVisible(false)}
        />

        {/**End Modal Ajout des type inscription*/}

        {/* Modal Edition des type inscription*/}
        <CustomEditModal
          modalTitle="Modification type inscription"
          modalContent={editModalContent}
          visible={editModal}
          close={() => setEditModal(false)}
        />
        {/**End Modal Edition des type inscription*/}

      </div>

    </Layout>
  );
}
